import React, { useEffect, useState } from 'react';
import { useGLTF, Text, Line, Cone } from '@react-three/drei';
import { useParams } from 'react-router-dom';
function Glassmodel(props) {
  let [topmount, settopmount] = useState(false);
  let [facial, setfacial] = useState(true);
  let [heightmove] = useState(0);
  let [heightscaler] = useState(0);
  let para = useParams();
  const { nodes, materials } = useGLTF('/EasyGlassSmartLive.gltf');

  let [handlaufshow, sethandlaufshow] = useState(0);
  let variablewidth = 120.0000001;
  let textup;
  let length2 = parseInt(props.len2 / 10);
  let length1 = parseInt(props.len1 / 10);
  let length3 = parseInt(props.len3 / 10);
  //Wichtig für anpassung 1.0.2
  let amount = parseInt(length1) / variablewidth;
  let amount2 = parseInt(length2) / variablewidth;
  let amount3 = parseInt(length3) / variablewidth;
  let [heightmeasureadjust, setheightmeasureadjust] = useState(0);
  let [colorr, setcolorr] = useState();
  let [ugcol, setugcol] = useState();
  let adjuster = 0;
  let [scaleaddition, setscaleaddition] = useState(0);
  let muricaheight = 36;
  if (props.hohe == 900) {
    muricaheight = 36;
    if (topmount) {
      heightscaler = 98 / 100;
      heightmove = -5;
    }
    if (facial) {
      heightscaler = 1;
      heightmove = 0;
    }
  }
  if (props.hohe == 1000) {
    if (topmount) {
      heightscaler = 1;
      heightmove = 0;
      muricaheight = 42;
    }
    if (facial) {
      heightscaler = 105 / 100;
      heightmove = 5;
      muricaheight = 42;
    }
  }
  if (props.hohe == 1100) {
    if (topmount) {
      heightscaler = 102.5 / 100;
      heightmove = 5;
      muricaheight = 48;
    }
    if (facial) {
      heightscaler = 105 / 100;
      heightmove = 10;
      muricaheight = 48;
    }
  }

  useEffect(() => {
    if (props.colorr == 'black') {
      //setcolorr("black")
      setcolorr('#D0D5D9');
    }
    if (props.colorr == 'anrtz') {
      //setcolorr("#293133")
      setcolorr('#D0D5D9');
    }
    if (props.colorr == 'gray') {
      setcolorr('#D0D5D9');
    }
    if (props.colorr == 'brano') {
      setcolorr('#D0D5D9');
    }
  }, [props.colorr]);

  useEffect(() => {
    if (props.untergrund == 'holz') {
      setugcol('#6d3d2d');
    }
    if (props.untergrund == 'metall') {
      setugcol('#C0C0C0');
    }
    if (props.untergrund == 'beton') {
      setugcol('white');
    }
  }, [props.untergrund]);
  useEffect(() => {
    if (props.montageart == 'top') {
      settopmount(true);
      setfacial(false);
    } else {
      settopmount(false);
      setfacial(true);
    }
  }, [props.montageart]);

  useEffect(() => {
    if (props.handlaufmat == 'edgep') {
      sethandlaufshow(0);
      setscaleaddition(0);
      setheightmeasureadjust(-0.05);
    }
    if (props.handlaufmat == 'round') {
      sethandlaufshow(1);
      setscaleaddition(0);
      setheightmeasureadjust(0.1);
    }
    if (props.handlaufmat == 'normal') {
      sethandlaufshow(0);
      setscaleaddition(0.7);
      setheightmeasureadjust(0);
    }
    if (props.handlaufmat == 'none') {
      sethandlaufshow(3);
      setscaleaddition(0);
      setheightmeasureadjust(-0.05);
    }
  }, [props.handlaufmat]);

  function wallrender(measureadjust, step) {
    let topmountscalor = 0;
    let heightadjust = 0;

    if (topmount) {
      topmountscalor = 0.8;
      heightadjust = -0.48;
    }
    if (facial) {
      heightadjust = +0.48;
      topmountscalor = 0.82;
    }
    if (step == 1) {
      return (
        <mesh
          position={[-props.len1 / 100 - 1.1, 6 + heightadjust, 0 - props.len2 / 200 + 1 - 0.1]}
          visible={props.wall1}
          material={materials['physi concrete']}
        >
          <boxGeometry args={[2, 13, 3.8 - topmountscalor]} />
          <meshStandardMaterial color={'#333'} />
        </mesh>
      );
    }
    if (step == 2) {
      return (
        <mesh
          position={[-props.len3 / 100 - 1.1, 6 + heightadjust, 0 + props.len2 / 200 - 1 + 0.1]}
          visible={props.wall2}
          material={materials['physi concrete']}
        >
          <boxGeometry args={[2, 13, 3.8 - topmountscalor]} />
          <meshStandardMaterial color={'#333'} />
        </mesh>
      );
    }

    if (step == 3) {
      return (
        <mesh
          position={[-1 + 0.1, 6 + heightadjust, props.len2 / 200 + 1.1]}
          visible={props.wall2}
          material={materials['physi concrete']}
        >
          <boxGeometry args={[3.8 - topmountscalor, 13, 2]} />
          <meshStandardMaterial color={'#333'} />
        </mesh>
      );
    }

    if (step == 4) {
      return (
        <mesh
          position={[1, 6 + heightadjust, 0 - props.len2 / 200 + 1 - 0.1]}
          visible={props.wall2}
          material={materials['physi concrete']}
        >
          <boxGeometry args={[2, 13, 3.8 - topmountscalor]} />
          <meshStandardMaterial color={'#333'} />
        </mesh>
      );
    }
  }

  amount = parseInt(amount);
  amount2 = parseInt(amount2);
  amount3 = parseInt(amount3);
  amount = amount + 1;
  amount2 = amount2 + 1;
  amount3 = amount3 + 1;

  let singlelength = length1 / amount;
  let singlelength2 = length2 / amount2;
  let singlelength3 = length3 / amount3;

  singlelength2 = singlelength2 / 10;
  singlelength3 = singlelength3 / 10;
  singlelength = singlelength / 10;

  let pointies = [];
  let pointies2 = [];
  let pointies3 = [];

  let adjustcorners = 0.05;
  let textscale = [1, 1, 1];
  let measureadjust = 0;

  if (props.height == 900) {
    muricaheight = 36;
  }
  if (props.height == 1000) {
    muricaheight = 42;
  }
  if (props.height == 1100) {
    muricaheight = 48;
  }
  //pointies.push([0,0,singlelength])
  for (let i = 0; i <= amount; i++) {
    pointies.push([0, singlelength * i * 10]);
  }
  for (let i = 0; i <= amount2; i++) {
    pointies2.push([0, singlelength2 * i * 10]);
  }
  for (let i = 0; i <= amount3; i++) {
    pointies3.push([length2 / 10, singlelength3 * i * 10]);
  }
  /*Now  lower */
  let Rcornermove = -(25 - 0.05 * (props.len2 - 500)) - 20;
  let Lcornermove = 25 - 0.05 * (props.len2 - 500) + 20;
  let facialadjuster1 = 0;
  let facialadjuster2 = 0;
  if (facial) {
    facialadjuster1 = 10;
    facialadjuster2 = -10;
  }
  let scale = props.len2 / 1000 - adjustcorners;
  let scale2 = props.len1 / 1000;
  let scale3 = props.len3 / 1000;
  let cornerrender = false;
  let cornerrender2 = false;
  let cornerscaler = 0;
  let floorscaleadjust = 0.0094;
  let pointpointadjust = 0;
  //let pointscaleadjust = 0.003 - (0.0000002*(props.len2-500))
  let pointscaleadjust = 0.0004;
  let pickyadjust = 0.6;
  if (props.len2 > 499 && props.len2 < 1000) {
    pointscaleadjust = -0.002;
    pickyadjust = 0.6;
  }
  if (props.len2 > 499 && props.len2 < 1000 && props.form == 'l') {
    floorscaleadjust = 1;
  }
  if (props.len2 > 499 && props.len2 < 700 && props.form == 'l') {
    floorscaleadjust = 1.4;
  }
  if (props.len2 >= 1000 && props.len2 < 1500) {
    pointscaleadjust = -0.0005;
    pickyadjust = 0.66;
    floorscaleadjust = 0.5;
  }
  if (props.len2 >= 1500 && props.len2 < 2000) {
    pointscaleadjust = -0.0003;
    pickyadjust = 0.64;
  }
  if (props.len2 >= 2000 && props.len2 < 2500) {
    pointscaleadjust = -0.00005;
    pickyadjust = 0.63;
  }
  if (props.len2 >= 2500 && props.len2 < 3500) {
    pointscaleadjust = 0.00005;
    pickyadjust = 0.62;
  }
  if (props.len2 >= 3500 && props.len2 < 4500) {
    pointscaleadjust = 0.000025;
    pickyadjust = 0.58;
  }
  if (props.len2 >= 4500 && props.len2 < 5500) {
    pointscaleadjust = 0.0002;
  }
  if (props.len2 >= 5500 && props.len2 < 7500) {
    pointscaleadjust = 0.00025;
  }
  if (props.len2 >= 7500 && props.len2 < 9500) {
    pointscaleadjust = 0.0003;
  }
  if (props.len2 >= 9500 && props.len2 < 11500) {
    pointscaleadjust = 0.00035;
  }
  if (props.len2 >= 11500 && props.len2 < 15000) {
    pointscaleadjust = 0.00039;
  }
  if (props.len1 || props.len2 || props.len3) {
    textscale = [1, 1, 1];
    textup = 0.1;
  }
  if (props.len1 > 3000 || props.len2 > 3000 || props.len3 > 3000) {
    textscale = [1.5, 1.5, 1.5];
    textup = 0.75;
  }
  if (props.len1 > 5000 || props.len2 > 5000 || props.len3 > 5000) {
    textscale = [2, 2, 2];
    textup = 1;
  }
  if (props.len1 > 8000 || props.len2 > 8000 || props.len3 > 8000) {
    textscale = [2.5, 2.5, 2.5];
    textup = 1.25;
  }
  if (props.len1 > 12000 || props.len2 > 12000 || props.len3 > 12000) {
    textscale = [3, 3, 3];
    textup = 1.5;
  }
  if (props.len1 > 2000 && props.form == 'i') {
    adjuster = 6;
  }
  if (props.len1 > 3000 || props.len3 > 3000) {
    adjuster = 9;
  }
  if (props.len1 > 4000 || props.len3 > 4000) {
    adjuster = 15;
  }
  if (props.len1 > 5000 || props.len3 > 5000) {
    adjuster = 20;
  }
  if (props.len1 > 7000 || props.len3 > 7000) {
    adjuster = 25;
  }
  if (props.len1 > 9000 || props.len3 > 9000) {
    adjuster = 35;
  }
  if (props.len1 > 11000 || props.len3 > 11000) {
    adjuster = 45;
  }
  if (props.len1 > 12000 || props.len3 > 12000) {
    adjuster = 55;
  }
  if (props.len1 > 13000 || props.len3 > 13000) {
    adjuster = 58;
  }
  if (props.len1 > 14000 || props.len3 > 14000) {
    adjuster = 65;
  }
  if (facial) {
    cornerrender2 = true;
  }
  if (topmount) {
    cornerrender = true;
  }
  if (props.form == 'l') {
    cornerrender = false;
    cornerrender2 = false;
    cornerscaler = 0.05;
  }

  let side1move = -2.482 - 0.005 * (props.len2 - 500);
  function renderglass(indexer) {
    if (indexer == 2) {
      return (
        <>
          {pointies2.map((item, index) => {
            if (index < pointies2.length - 1 && (props.form == 'u' || props.form == 'l')) {
              let currentCoord = item;
              let nextCoord = pointies2[index + 1];
              let little = 0;

              let midpoint = [(currentCoord[0] + nextCoord[0]) / 2, (currentCoord[1] + nextCoord[1]) / 2];
              if (index < pointies2.length - 1) {
                return (
                  <>
                    <mesh
                      geometry={nodes.Glass_Front_1.geometry}
                      material={materials['Glass Frosted']}
                      position={[0.43, 35 + heightmove, midpoint[1] - props.len2 / 20]}
                      scale={[1, heightscaler, singlelength2 / 10 + little]}
                    />
                    <mesh
                      geometry={nodes.Glass_Front_2.geometry}
                      material={materials['Glass Frosted']}
                      position={[-0.43, 35 + heightmove, midpoint[1] - props.len2 / 20]}
                      scale={[1, heightscaler, singlelength2 / 10]}
                    />
                  </>
                );
              }
            }
          })}
        </>
      );
    }
    if (indexer == 3) {
      return (
        <>
          {pointies.map((item, index) => {
            if (index < pointies.length - 1 && (props.form == 'u' || props.form == 'l' || props.form == 'i')) {
              let currentCoord = item;
              let nextCoord = pointies[index + 1];
              let little = 0;

              let midpoint = [(currentCoord[0] + nextCoord[0]) / 2, (currentCoord[1] + nextCoord[1]) / 2];
              if (index < pointies.length - 1) {
                return (
                  <>
                    <mesh
                      geometry={nodes.Glass_Front_1.geometry}
                      material={materials['Glass Frosted']}
                      position={[0.43, 35 + heightmove, midpoint[1] - props.len1 / 20]}
                      scale={[1, heightscaler, singlelength / 10 + little]}
                    />
                    <mesh
                      geometry={nodes.Glass_Front_2.geometry}
                      material={materials['Glass Frosted']}
                      position={[-0.43, 35 + heightmove, midpoint[1] - props.len1 / 20]}
                      scale={[1, heightscaler, singlelength / 10]}
                    />
                  </>
                );
              }
            }
          })}
        </>
      );
    }

    if (indexer == 4) {
      return (
        <>
          {pointies3.map((item, index) => {
            if (index < pointies3.length - 1 && props.form == 'u') {
              let currentCoord = item;
              let nextCoord = pointies3[index + 1];
              let little = 0;

              let midpoint = [(currentCoord[0] + nextCoord[0]) / 2, (currentCoord[1] + nextCoord[1]) / 2];
              if (index < pointies3.length - 1) {
                return (
                  <>
                    <mesh
                      geometry={nodes.Glass_Front_1.geometry}
                      material={materials['Glass Frosted']}
                      position={[0.43, 35 + heightmove, midpoint[1] - props.len3 / 20]}
                      scale={[1, heightscaler, singlelength3 / 10 + little]}
                    />
                    <mesh
                      geometry={nodes.Glass_Front_2.geometry}
                      material={materials['Glass Frosted']}
                      position={[-0.43, 35 + heightmove, midpoint[1] - props.len3 / 20]}
                      scale={[1, heightscaler, singlelength3 / 10]}
                    />
                  </>
                );
              }
            }
          })}
        </>
      );
    }
  }
  let adjustrail = 0;
  if (topmount) {
    adjustrail = 0.2;
  } else {
    adjustrail = 1.5;
  }

  return (
    <>
      <group position={[12 + adjuster, 3, 0]}>
        {(props.form == 'l' || props.form == 'u' || props.form == 'i') && (
          <>
            <group
              {...props}
              dispose={null}
              scale={[0.1, 0.1, 0.1]}
              rotation-y={Math.PI / 2}
              position={[0 - props.len1 / 200 - 0.08, 0, 0 + side1move]}
            >
              <group position={[0, 16.14, 0]} scale={[1, 1, 1]}>
                {renderglass(3)}
              </group>
              <mesh
                geometry={nodes.Handrail_Endcap_Front_L.geometry}
                material={materials['physi alu bright']}
                visible={false}
                position={[0, 65.14 + heightmove + 36.86, -0.11 - props.len1 / 20]}
              />
              <mesh
                geometry={nodes.Handrail_Endcap_Front_R.geometry}
                material={materials['physi alu bright']}
                visible={false}
                position={[0, 0 + 65.14 + heightmove + 36.86, props.len1 / 20]}
              />
              <mesh
                geometry={nodes.Smart_Endcap_Front_R.geometry}
                visible={props.form == 'i'}
                material={materials['physi alu bright']}
                material-color={colorr}
                position={[0, 5.9, props.len1 / 20]}
              />
              <mesh
                geometry={nodes.Smart_Endcap_Front_L.geometry}
                material={materials['physi alu bright']}
                position={[0, 5.9, -0.11 - props.len1 / 20]}
              />
              <group position={[0, 36.86, 0]} scale={[1, 1, scale2]}>
                <group position={[0, -36.86, -50]} rotation={[0, 0, -Math.PI]} scale={[1, 1, 1]}>
                  <mesh
                    geometry={nodes.Smart_Front.geometry}
                    material={materials['physi alu bright']}
                    position={[0, -1.5, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Gasket_Front.geometry}
                    material={materials.rubber}
                    position={[0, -1.5, 0]}
                  />
                </group>

                <group
                  position={[0, 65.14 + heightmove + adjustrail, -50]}
                  scale={[1, 0.3 + scaleaddition, 1]}
                  visible={handlaufshow == 0}
                >
                  <mesh geometry={nodes.Handrail_Front_1.geometry} material={materials['physi alu bright']} />
                  <mesh geometry={nodes.Handrail_Front_Gasket.geometry} material={materials.rubber} />
                </group>

                {/*NEUNEUNEU */}
                <group position={[0.001, 65.137 + heightmove + adjustrail, -50]} visible={handlaufshow == 1}>
                  <mesh
                    geometry={nodes.Edge_Protection_Front__1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, -0.1, 0]}
                  />
                  <mesh
                    geometry={nodes.Edge_Protection_Front_Gasket.geometry}
                    material={materials.rubber}
                    position={[0, 1.07, 50]}
                  />
                </group>
                <group position={[0.001, 65.137 + heightmove + adjustrail, -50]} visible={handlaufshow == 1}>
                  <mesh
                    geometry={nodes.Handrail_ROUND_Front_Gasket.geometry}
                    material={materials.rubber}
                    position={[0, 0.064, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Front_R.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 100.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Wallflange_Front_R.geometry}
                    visible={props.wall2 && props.form == 'i'}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 100.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Front_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -0.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Wallflange_Front_L.geometry}
                    visible={props.wall1}
                    material={materials['physi alu bright']}
                    position={[-0.007, 0.512, -0.16 + 0.2]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Front_2.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 0]}
                  />
                </group>
                {/*NEUNEUNEU */}

                <mesh
                  visible={topmount}
                  geometry={nodes.Floor_Front.geometry}
                  material={materials['physi concrete']}
                  material-color={ugcol}
                  scale={[1, 1, 1]}
                  position={[-9, -41.86, 0]}
                />
                <mesh
                  visible={facial}
                  geometry={nodes.Floor_Front_Fascia_outside.geometry}
                  material={materials['physi concrete']}
                  material-color={ugcol}
                  scale={[1, 1, 1 - 0.0025]}
                  position={[-13.45, -30.96, 0 - floorscaleadjust]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Floor_Front_Fascia_inside.geometry}
                  material={materials['physi concrete']}
                  position={[-13.45, -30.96, 0]}
                />
                <mesh
                  visible={facial}
                  geometry={nodes.Smart_Cover_Fascia_Front.geometry}
                  material={materials['physi alu bright']}
                  position={[3.4, -36.86, -50]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Blind_Plug_Front_1.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, -31.69, -40]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Blind_Plug_Front_2.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, -31.69, 40]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, -50 + Lcornermove]} rotation={[-Math.PI, 0, -Math.PI / 2]} visible={false}>
                <group position={[102, 0, 19.8]} rotation={[0, 0, -Math.PI / 2]} visible={handlaufshow == 0}>
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Top_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[20.11, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[53, -10.4, 19.8]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Top_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Top_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 0]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 0]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R2.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Top_Corner_L.geometry}
                  material={materials['physi alu bright']}
                  position={[5.9, -19.91, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Top_Corner_L.geometry}
                  material={materials['physi concrete']}
                  position={[-5, -9, 13]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, 50 + Rcornermove]} visible={false}>
                <group position={[0, 102, 19.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Top_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -19.91]}
                  />
                </group>
                <group position={[-10.5, 53, 19.8]} rotation={[0, -1.57, 0]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Top_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Top_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R1_1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R2_1.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 0]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R1_1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R2_1.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 0]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Top_Corner_R.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.91, 5.9, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Top_Corner_R.geometry}
                  material={materials['physi concrete']}
                  position={[-9, -5, 13]}
                  rotation={[0, 1.57, 0]}
                />
              </group>
              <group position={[0, 0, -50]} rotation={[-Math.PI, 0, -Math.PI / 2]} visible={false}>
                <group position={[0, 3.5, 33.3]} rotation={[-Math.PI, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-100, 0, 0]}
                    rotation={[0, 1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_L2.geometry}
                    material={materials['physi alu bright']}
                  />
                </group>
                <group position={[102, 0, 29.8]} rotation={[0, 0, -Math.PI / 2]} visible={facial}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    visible={handlaufshow == 0}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    visible={handlaufshow == 0}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_L1.geometry}
                    material={materials.rubber}
                    visible={handlaufshow == 0}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_L2.geometry}
                    material={materials.rubber}
                    visible={handlaufshow == 0}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_Outside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    visible={handlaufshow == 0}
                    position={[29.91, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[53, -15.4, 29.8]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_L1.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, 3.1, 10]}
                  rotation={[-Math.PI, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_L2.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -19.9, 32.85]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_L1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 10]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_L2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_L1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 10]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_L2.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_outside_Corner_L.geometry}
                  material={materials['physi alu bright']}
                  position={[5.9, -29.91, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_outside_L.geometry}
                  material={materials['physi concrete']}
                  position={[5.9, -16.5, 13.3]}
                  rotation={[Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, 50]} visible={false}>
                <group position={[3.5, 0, 33.3]} rotation={[0, -1.57, 0]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[-100, 0, 0]}
                    rotation={[0, 1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_R2.geometry}
                    material={materials['physi alu bright']}
                  />
                </group>
                <group position={[0, 102, 29.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_Outside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -29.81]}
                  />
                </group>
                <group position={[-15.4, 53, 29.8]} rotation={[0, -1.57, 0]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_R1.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, 5.18, 10]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_R2.geometry}
                  material={materials['physi concrete']}
                  position={[-19.9, 5.18, 32.85]}
                  rotation={[Math.PI / 2, -Math.PI / 2, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_R2.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_outside_Corner_R.geometry}
                  material={materials['physi alu bright']}
                  position={[-29.91, 5.9, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_outside_R.geometry}
                  material={materials['physi concrete']}
                  position={[-16.5, 5.9, 13.3]}
                  rotation={[0, -1.57, 0]}
                />
              </group>
              <group position={[0, 0, -50]} rotation={[-Math.PI, 0, -Math.PI]} visible={false}>
                <group position={[-50.2, 0, 23.6]} rotation={[-Math.PI, 0, -Math.PI]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-46.6, 0, -3.4]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[46.6, 0, 3.4]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[0, 102, 23.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_inside_Corner_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -23.81]}
                  />
                </group>
                <group position={[-12.5, 53, 23.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Inside_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Inside_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_L1.geometry}
                  material={materials['physi concrete']}
                  position={[-3.1, 5.18, 10]}
                  rotation={[-Math.PI, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_L2.geometry}
                  material={materials['physi concrete']}
                  position={[-13.8, 5.18, 20.75]}
                  rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_inside_Corner_L1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_inside_Corner_L2.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 4]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_L1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_L2.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 4]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_inside_Corner_L.geometry}
                  material={materials['physi alu bright']}
                  position={[-23.91, 5.9, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_inside_L.geometry}
                  material={materials['physi concrete']}
                  position={[-10.3, 5.9, 37.25]}
                  rotation={[0, -1.57, 0]}
                />
              </group>
              <group position={[0, 0, 50]} rotation={[0, 0, Math.PI / 2]} visible={false}>
                <group position={[0, -0.2, -26.4]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[-46.6, 0, -3.4]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[46.6, 0, 3.4]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[102, 0, 23.8]} rotation={[0, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_inside_Corner_R.geometry}
                    material={materials['physi alu bright']}
                    position={[23.91, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[53, -12.5, 23.8]} rotation={[-Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_inside_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_inside_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_R1.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -3.1, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_R2.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -13.8, 20.75]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 4]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 4]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R2_1.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_inside_Corner_R.geometry}
                  material={materials['physi alu bright']}
                  position={[5.9, -23.91, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_inside_R.geometry}
                  material={materials['physi concrete']}
                  position={[5.9, -10.3, 37.25]}
                  rotation={[Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
            </group>
            {wallrender(measureadjust, 1)}
            {props.form == 'i' && wallrender(measureadjust, 4)}
          </>
        )}

        {(props.form == 'l' || props.form == 'u') && (
          <>
            <group {...props} dispose={null} scale={[0.1, 0.1, 0.1]}>
              <group position={[0, 16.14, 0]} scale={[1, 1, 1]}>
                {renderglass(2)}
              </group>
              <mesh
                geometry={nodes.Handrail_Endcap_Front_L.geometry}
                material={materials['physi alu bright']}
                visible={false}
                position={[0, 65.14 + heightmove + 36.86, -0.11 - props.len2 / 20]}
              />
              <mesh
                geometry={nodes.Handrail_Endcap_Front_R.geometry}
                material={materials['physi alu bright']}
                visible={false}
                position={[0, 0 + 65.14 + heightmove + 36.86, props.len2 / 20]}
              />
              <mesh
                geometry={nodes.Smart_Endcap_Front_R.geometry}
                visible={props.form == 'l'}
                material={materials['physi alu bright']}
                material-color={colorr}
                position={[0, 5.9, props.len2 / 20]}
              />
              <mesh
                geometry={nodes.Smart_Endcap_Front_L.geometry}
                visible={false}
                material={materials['physi alu bright']}
                position={[0, 5.9, -0.11 - props.len2 / 20]}
              />
              <group position={[0, 36.86, 0]} scale={[1, 1, scale + cornerscaler]}>
                <group position={[0, -36.86, -50]} rotation={[0, 0, -Math.PI]} scale={[1, 1, 1]}>
                  <mesh
                    geometry={nodes.Smart_Front.geometry}
                    material={materials['physi alu bright']}
                    position={[0, -1.5, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Gasket_Front.geometry}
                    material={materials.rubber}
                    position={[0, -1.5, 0]}
                  />
                </group>

                <group
                  position={[0, 65.14 + heightmove + adjustrail, -50]}
                  scale={[1, 0.3 + scaleaddition, 1]}
                  visible={handlaufshow == 0}
                >
                  <mesh geometry={nodes.Handrail_Front_1.geometry} material={materials['physi alu bright']} />
                  <mesh geometry={nodes.Handrail_Front_Gasket.geometry} material={materials.rubber} />
                </group>

                {/*NEUNEUNEU */}
                <group position={[0.001, 65.137 + heightmove + adjustrail, -50]} visible={handlaufshow == 1}>
                  <mesh
                    geometry={nodes.Edge_Protection_Front__1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, -0.1, 0]}
                  />
                  <mesh
                    geometry={nodes.Edge_Protection_Front_Gasket.geometry}
                    material={materials.rubber}
                    position={[0, 1.07, 50]}
                  />
                </group>
                <group position={[0.001, 65.137 + heightmove + adjustrail, -50]} visible={handlaufshow == 1}>
                  <mesh
                    geometry={nodes.Handrail_ROUND_Front_Gasket.geometry}
                    material={materials.rubber}
                    position={[0, 0.064, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Front_R.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 100.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Wallflange_Front_R.geometry}
                    visible={props.wall2 && props.form == 'l'}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 100.16 - 0.2]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Front_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -0.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Wallflange_Front_L.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[-0.007, 0.512, -0.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Front_2.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 0]}
                  />
                </group>
                {/*NEUNEUNEU */}

                <mesh
                  visible={topmount}
                  geometry={nodes.Floor_Front.geometry}
                  material={materials['physi concrete']}
                  scale={[1, 1, 1]}
                  position={[-9, -41.86, 0]}
                />
                <mesh
                  visible={facial}
                  geometry={nodes.Floor_Front_Fascia_outside.geometry}
                  material={materials['physi concrete']}
                  scale={[1, 1, 1 - 0.01]}
                  position={[-13.45, -30.96, 0 + 0.1785 + floorscaleadjust]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Floor_Front_Fascia_inside.geometry}
                  material={materials['physi concrete']}
                  position={[-13.45, -30.96, 0]}
                />
                <mesh
                  visible={facial}
                  geometry={nodes.Smart_Cover_Fascia_Front.geometry}
                  material={materials['physi alu bright']}
                  position={[3.4, -36.86, -50]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Blind_Plug_Front_1.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, -31.69, -40]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Blind_Plug_Front_2.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, -31.69, 40]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, -50 + Lcornermove]} rotation={[-Math.PI, 0, -Math.PI / 2]} visible={topmount}>
                <group
                  position={[102 + heightmove + adjustrail, 0, 19.8]}
                  rotation={[0, 0, -Math.PI / 2]}
                  scale={[1, 0.3 + scaleaddition, 1]}
                  visible={handlaufshow == 0}
                >
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Top_Corner_L2.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[20.11, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>

                {/*NEUNEUNEU2 */}
                <group
                  position={[102 + heightmove + adjustrail, 0, 19.78]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  visible={handlaufshow == 1}
                >
                  <mesh
                    geometry={nodes.Handrail_ROUND_Top_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-29.78, 0.5, 0]}
                    rotation={[0, 1.571, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Top_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -29.8]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Gasket_Top_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[-29.78, 0.064, 0]}
                    rotation={[0, 1.571, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Gasket_Top_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[0, 0.064, -29.8]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Top_Endcap_Corner_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -19.93]}
                    rotation={[-Math.PI / 2, 0, -Math.PI]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Top_Wallflange_Corner_L.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -19.93]}
                    rotation={[-Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                {/*NEUNEUNEU2 */}

                <group position={[53, -10.4, 19.8]} rotation={[Math.PI / 2, 0, -Math.PI / 2]} visible={false}>
                  <mesh
                    geometry={nodes.Glass_Corner_Top_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Top_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 0]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 0]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R2.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Top_Corner_L.geometry}
                  visible={false}
                  material={materials['physi alu bright']}
                  position={[5.9, -19.91, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Top_Corner_L.geometry}
                  material={materials['physi concrete']}
                  position={[-5, -9, 13]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, 50 + Rcornermove]} visible={cornerrender}>
                <group
                  position={[0, 102 + heightmove + adjustrail, 19.8]}
                  scale={[1, 0.3 + scaleaddition, 1]}
                  rotation={[0, 1.57, 0]}
                  visible={handlaufshow == 0}
                >
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Top_Corner_R1.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[0, 0, -19.91]}
                  />
                </group>

                {/*NEUNEUNEU2 */}
                <group
                  position={[0, 102 + heightmove + adjustrail, 19.78]}
                  rotation={[0, 0, 0]}
                  visible={handlaufshow == 1}
                >
                  <mesh
                    geometry={nodes.Handrail_ROUND_Fascia_Outside_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-29.78, 0.5, 0]}
                    rotation={[0, 1.571, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Fascia_Outside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -29.8]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Gasket_Fascia_Outside_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[-29.78, 0.064, 0]}
                    rotation={[0, 1.571, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Gasket_Fascia_Outside_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[0, 0.064, -29.8]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Fascia_Outside_Corner_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -29.95]}
                    rotation={[-Math.PI / 2, 0, -Math.PI]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Wallflange_Fascia_Outside_Corner_L.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -29.95]}
                    rotation={[-Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                {/*NEUNEUNEU2 */}

                <group position={[-10.5, 53, 19.8]} rotation={[0, -1.57, 0]} visible={false}>
                  <mesh
                    geometry={nodes.Glass_Corner_Top_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Top_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R1_1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R2_1.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 0]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R1_1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R2_1.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 0]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Top_Corner_R.geometry}
                  visible={false}
                  material={materials['physi alu bright']}
                  position={[-19.91, 5.9, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Top_Corner_R.geometry}
                  material={materials['physi concrete']}
                  position={[-9, -5, 13]}
                  rotation={[0, 1.57, 0]}
                />
              </group>
              <group
                position={[0, 0, -50 + Lcornermove + facialadjuster1]}
                rotation={[-Math.PI, 0, -Math.PI / 2]}
                visible={facial}
              >
                <group position={[0, 3.5, 33.3]} rotation={[-Math.PI, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-100, 0, 0]}
                    rotation={[0, 1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_L2.geometry}
                    material={materials['physi alu bright']}
                  />
                </group>
                <group
                  position={[102 + heightmove + adjustrail, 0, 29.8]}
                  scale={[1, 0.3 + scaleaddition, 1]}
                  rotation={[0, 0, -Math.PI / 2]}
                  visible={facial}
                >
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_L1.geometry}
                    visible={handlaufshow == 0}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_L2.geometry}
                    visible={handlaufshow == 0}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_L1.geometry}
                    visible={handlaufshow == 0}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_L2.geometry}
                    visible={handlaufshow == 0}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_Outside_Corner_L2.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[29.91, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                {/*NEUNEUNEU2 */}
                <group
                  position={[102 + heightmove + adjustrail, 0, 29.78]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  visible={handlaufshow == 1}
                >
                  <mesh
                    geometry={nodes.Handrail_ROUND_Fascia_Outside_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-29.78, 0.5, 0]}
                    rotation={[0, 1.571, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Fascia_Outside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -29.8]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Gasket_Fascia_Outside_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[-29.78, 0.064, 0]}
                    rotation={[0, 1.571, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Gasket_Fascia_Outside_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[0, 0.064, -29.8]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Fascia_Outside_Corner_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -29.95]}
                    rotation={[-Math.PI / 2, 0, -Math.PI]}
                  />
                  <mesh
                    visible={false}
                    geometry={nodes.Handrail_ROUND_Wallflange_Fascia_Outside_Corner_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -29.95]}
                    rotation={[-Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                {/*NEUNEUNEU2 */}

                <group position={[53, -15.4, 29.8]} rotation={[Math.PI / 2, 0, -Math.PI / 2]} visible={false}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_L1.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, 3.1, 10]}
                  rotation={[-Math.PI, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_L2.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -19.9, 32.85]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_L1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 10]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_L2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_L1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 10]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_L2.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_outside_Corner_L.geometry}
                  visible={false}
                  material={materials['physi alu bright']}
                  position={[5.9, -29.91, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_outside_L.geometry}
                  visible={false}
                  material={materials['physi concrete']}
                  position={[5.9, -16.5, 13.3]}
                  rotation={[Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, 50 + Rcornermove + facialadjuster2]} visible={cornerrender2}>
                <group position={[3.5, 0, 33.3]} rotation={[0, -1.57, 0]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[-100, 0, 0]}
                    rotation={[0, 1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_R2.geometry}
                    material={materials['physi alu bright']}
                  />
                </group>
                <group
                  position={[0, 102 + heightmove + adjustrail, 29.8]}
                  rotation={[0, 1.57, 0]}
                  scale={[1, 0.3 + scaleaddition, 1]}
                  visible={handlaufshow == 0}
                >
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_Outside_Corner_R1.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[0, 0, -29.81]}
                  />
                </group>
                {/*NEUNEUNEU2 */}
                <group position={[0, 102 + heightmove + adjustrail, 29.8]} visible={handlaufshow == 1}>
                  <mesh
                    geometry={nodes.Handrail_ROUND_Fascia_Outside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[-29.78, 0.5, 0]}
                    rotation={[0, 1.571, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Fascia_Outside_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -29.8]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Gasket_Fascia_Outside_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[-29.78, 0.064, 0]}
                    rotation={[0, 1.571, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Gasket_Fascia_Outside_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[0, 0.064, -29.8]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Fascia_Outside_Corner_R.geometry}
                    material={materials['physi alu bright']}
                    position={[-29.93, 0.5, 0]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  />
                  <mesh
                    visible={false}
                    geometry={nodes.Handrail_ROUND_Wallflange_Fascia_Outside_Corner_R.geometry}
                    material={materials['physi alu bright']}
                    position={[-29.93, 0.5, 0]}
                    rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                  />
                </group>
                {/*NEUNEUNEU2 */}
                <group position={[-15.4, 53, 29.8]} rotation={[0, -1.57, 0]} visible={false}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_R1.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, 5.18, 10]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_R2.geometry}
                  material={materials['physi concrete']}
                  position={[-19.9, 5.18, 32.85]}
                  rotation={[Math.PI / 2, -Math.PI / 2, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_R2.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_outside_Corner_R.geometry}
                  visible={false}
                  material={materials['physi alu bright']}
                  position={[-29.91, 5.9, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_outside_R.geometry}
                  visible={false}
                  material={materials['physi concrete']}
                  position={[-16.5, 5.9, 13.3]}
                  rotation={[0, -1.57, 0]}
                />
              </group>
              <group position={[0, 0, -50]} rotation={[-Math.PI, 0, -Math.PI]} visible={false}>
                <group position={[-50.2, 0, 23.6]} rotation={[-Math.PI, 0, -Math.PI]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-46.6, 0, -3.4]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[46.6, 0, 3.4]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[0, 102, 23.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_inside_Corner_L.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[0, 0, -23.81]}
                  />
                </group>
                <group position={[-12.5, 53, 23.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Inside_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Inside_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_L1.geometry}
                  material={materials['physi concrete']}
                  position={[-3.1, 5.18, 10]}
                  rotation={[-Math.PI, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_L2.geometry}
                  material={materials['physi concrete']}
                  position={[-13.8, 5.18, 20.75]}
                  rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_inside_Corner_L1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_inside_Corner_L2.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 4]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_L1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_L2.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 4]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_inside_Corner_L.geometry}
                  visible={false}
                  material={materials['physi alu bright']}
                  position={[-23.91, 5.9, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_inside_L.geometry}
                  material={materials['physi concrete']}
                  position={[-10.3, 5.9, 37.25]}
                  rotation={[0, -1.57, 0]}
                />
              </group>
              <group position={[0, 0, 50]} rotation={[0, 0, Math.PI / 2]} visible={false}>
                <group position={[0, -0.2, -26.4]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[-46.6, 0, -3.4]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[46.6, 0, 3.4]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[102, 0, 23.8]} rotation={[0, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_inside_Corner_R.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[23.91, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[53, -12.5, 23.8]} rotation={[-Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_inside_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_inside_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_R1.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -3.1, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_R2.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -13.8, 20.75]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 4]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 4]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R2_1.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_inside_Corner_R.geometry}
                  visible={false}
                  material={materials['physi alu bright']}
                  position={[5.9, -23.91, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_inside_R.geometry}
                  material={materials['physi concrete']}
                  position={[5.9, -10.3, 37.25]}
                  rotation={[Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
            </group>
            {props.wall2 && props.form == 'l' && wallrender(measureadjust, 3, 1)}
          </>
        )}

        {props.form == 'u' && (
          <>
            <group
              {...props}
              dispose={null}
              scale={[0.1, 0.1, 0.1]}
              rotation-y={-Math.PI / 2}
              position={[0 - props.len3 / 200 - 0.08, 0, 0 - side1move]}
            >
              <group position={[0, 16.14, 0]} scale={[1, 1, 1]}>
                {renderglass(4)}
              </group>
              <mesh
                geometry={nodes.Handrail_Endcap_Front_L.geometry}
                material={materials['physi alu bright']}
                visible={false}
                position={[0, 65.14 + heightmove + 36.86, -0.11 - props.len3 / 20]}
              />
              <mesh
                geometry={nodes.Handrail_Endcap_Front_R.geometry}
                material={materials['physi alu bright']}
                visible={false}
                position={[0, 0 + 65.14 + heightmove + 36.86, props.len3 / 20]}
              />
              <mesh
                geometry={nodes.Smart_Endcap_Front_R.geometry}
                visible={props.form == 'u'}
                material={materials['physi alu bright']}
                material-color={colorr}
                position={[0, 5.9, props.len3 / 20]}
              />
              <mesh
                geometry={nodes.Smart_Endcap_Front_L.geometry}
                visible={false}
                material={materials['physi alu bright']}
                position={[0, 5.9, -0.11 - props.len3 / 20]}
              />
              <group position={[0, 36.86, 0]} scale={[1, 1, scale3]}>
                <group position={[0, -36.86, -50]} rotation={[0, 0, -Math.PI]} scale={[1, 1, 1]}>
                  <mesh
                    geometry={nodes.Smart_Front.geometry}
                    material={materials['physi alu bright']}
                    position={[0, -1.5, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Gasket_Front.geometry}
                    material={materials.rubber}
                    position={[0, -1.5, 0]}
                  />
                </group>

                <group
                  position={[0, 65.14 + heightmove + adjustrail, -50]}
                  scale={[1, 0.3 + scaleaddition, 1]}
                  visible={handlaufshow == 0}
                >
                  <mesh geometry={nodes.Handrail_Front_1.geometry} material={materials['physi alu bright']} />
                  <mesh geometry={nodes.Handrail_Front_Gasket.geometry} material={materials.rubber} />
                </group>

                {/*NEUNEUNEU */}
                <group position={[0.001, 65.137 + heightmove + adjustrail, -50]} visible={handlaufshow == 1}>
                  <mesh
                    geometry={nodes.Edge_Protection_Front__1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, -0.1, 0]}
                  />
                  <mesh
                    geometry={nodes.Edge_Protection_Front_Gasket.geometry}
                    material={materials.rubber}
                    position={[0, 1.07, 50]}
                  />
                </group>
                <group position={[0.001, 65.137 + heightmove + adjustrail, -50]} visible={handlaufshow == 1}>
                  <mesh
                    geometry={nodes.Handrail_ROUND_Front_Gasket.geometry}
                    material={materials.rubber}
                    position={[0, 0.064, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Front_R.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 100.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Wallflange_Front_R.geometry}
                    visible={props.wall2 && props.form == 'u'}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 100.16 - 0.2]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Endcap_Front_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, -0.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Wallflange_Front_L.geometry}
                    visible={false}
                    material={materials['physi alu bright']}
                    position={[-0.007, 0.512, -0.16]}
                    rotation={[-Math.PI / 2, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_ROUND_Front_2.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0.5, 0]}
                  />
                </group>
                {/*NEUNEUNEU */}

                <mesh
                  visible={topmount}
                  geometry={nodes.Floor_Front.geometry}
                  material={materials['physi concrete']}
                  scale={[1, 1, 1]}
                  position={[-9, -41.86, 0]}
                />
                <mesh
                  visible={facial}
                  geometry={nodes.Floor_Front_Fascia_outside.geometry}
                  scale={[1, 1, 1 - 0.0025]}
                  material={materials['physi concrete']}
                  position={[-13.45, -30.96, 0]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Floor_Front_Fascia_inside.geometry}
                  material={materials['physi concrete']}
                  position={[-13.45, -30.96, 0]}
                />
                <mesh
                  visible={facial}
                  geometry={nodes.Smart_Cover_Fascia_Front.geometry}
                  material={materials['physi alu bright']}
                  position={[3.4, -36.86, -50]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Blind_Plug_Front_1.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, -31.69, -40]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
                <mesh
                  visible={false}
                  geometry={nodes.Blind_Plug_Front_2.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, -31.69, 40]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, -50 + Lcornermove]} rotation={[-Math.PI, 0, -Math.PI / 2]} visible={false}>
                <group position={[102, 0, 19.8]} rotation={[0, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Top_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[20.11, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[53, -10.4, 19.8]} rotation={[Math.PI / 2, 0, -Math.PI / 2]} visible={false}>
                  <mesh
                    geometry={nodes.Glass_Corner_Top_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Top_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 0]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 0]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R2.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Top_Corner_L.geometry}
                  material={materials['physi alu bright']}
                  position={[5.9, -19.91, 19.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Top_Corner_L.geometry}
                  material={materials['physi concrete']}
                  position={[-5, -9, 13]}
                  rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, 50 + Rcornermove]} visible={false}>
                <group position={[0, 102, 19.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Top_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Top_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Top_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -19.91]}
                  />
                </group>

                <group position={[-10.5, 53, 19.8]} rotation={[0, -1.57, 0]} visible={false}>
                  <mesh
                    geometry={nodes.Glass_Corner_Top_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Top_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R1_1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Top_Corner_R2_1.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 0]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R1_1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Top_Corner_R2_1.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 0]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Top_Corner_R.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.91, 5.9, 19.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Top_Corner_R.geometry}
                  material={materials['physi concrete']}
                  position={[-9, -5, 13]}
                  rotation={[0, 1.57, 0]}
                />
              </group>
              <group position={[0, 0, -50]} rotation={[-Math.PI, 0, -Math.PI / 2]} visible={false}>
                <group position={[0, 3.5, 33.3]} rotation={[-Math.PI, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-100, 0, 0]}
                    rotation={[0, 1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_L2.geometry}
                    material={materials['physi alu bright']}
                  />
                </group>
                <group position={[102, 0, 29.8]} rotation={[0, 0, -Math.PI / 2]} visible={facial}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_Outside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[29.91, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[53, -15.4, 29.8]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_L1.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, 3.1, 10]}
                  rotation={[-Math.PI, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_L2.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -19.9, 32.85]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_L1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 10]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_L2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_L1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 10]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_L2.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_outside_Corner_L.geometry}
                  material={materials['physi alu bright']}
                  position={[5.9, -29.91, 29.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_outside_L.geometry}
                  material={materials['physi concrete']}
                  position={[5.9, -16.5, 13.3]}
                  rotation={[Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
              <group position={[0, 0, 50]} visible={false}>
                <group position={[3.5, 0, 33.3]} rotation={[0, -1.57, 0]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[-100, 0, 0]}
                    rotation={[0, 1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_outside_R2.geometry}
                    material={materials['physi alu bright']}
                  />
                </group>
                <group position={[0, 102, 29.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_Outside_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_Outside_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_Outside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -29.81]}
                  />
                </group>
                <group position={[-15.4, 53, 29.8]} rotation={[0, -1.57, 0]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Outside_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_R1.geometry}
                  material={materials['physi concrete']}
                  position={[3.1, 5.18, 10]}
                  rotation={[0, 0, -Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_outside_R2.geometry}
                  material={materials['physi concrete']}
                  position={[-19.9, 5.18, 32.85]}
                  rotation={[Math.PI / 2, -Math.PI / 2, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_outside_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_outside_Corner_R2.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_outside_Corner_R.geometry}
                  material={materials['physi alu bright']}
                  position={[-29.91, 5.9, 29.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_outside_R.geometry}
                  material={materials['physi concrete']}
                  position={[-16.5, 5.9, 13.3]}
                  rotation={[0, -1.57, 0]}
                />
              </group>
              <group position={[0, 0, -50]} rotation={[-Math.PI, 0, -Math.PI]} visible={false}>
                <group position={[-50.2, 0, 23.6]} rotation={[-Math.PI, 0, -Math.PI]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[-46.6, 0, -3.4]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[46.6, 0, 3.4]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[0, 102, 23.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_L1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_L2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_L1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_L2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_inside_Corner_L.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -23.81]}
                  />
                </group>
                <group position={[-12.5, 53, 23.8]} rotation={[0, 1.57, 0]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Inside_L1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_Inside_L2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_L1.geometry}
                  material={materials['physi concrete']}
                  position={[-3.1, 5.18, 10]}
                  rotation={[-Math.PI, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_L2.geometry}
                  material={materials['physi concrete']}
                  position={[-13.8, 5.18, 20.75]}
                  rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_inside_Corner_L1.geometry}
                  material={materials['physi alu bright']}
                  position={[-19.8, 1.5, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Profile_Fascia_inside_Corner_L2.geometry}
                  material={materials['physi alu bright']}
                  position={[0, 1.5, 4]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_L1.geometry}
                  material={materials.rubber}
                  position={[-19.8, 1.5, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_L2.geometry}
                  material={materials.rubber}
                  position={[0, 1.5, 4]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_inside_Corner_L.geometry}
                  material={materials['physi alu bright']}
                  position={[-23.91, 5.9, 23.8]}
                  rotation={[-Math.PI, 1.57, 0]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_inside_L.geometry}
                  material={materials['physi concrete']}
                  position={[-10.3, 5.9, 37.25]}
                  rotation={[0, -1.57, 0]}
                />
              </group>
              <group position={[0, 0, 50]} rotation={[0, 0, Math.PI / 2]} visible={false}>
                <group position={[0, -0.2, -26.4]} rotation={[Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[-46.6, 0, -3.4]}
                  />
                  <mesh
                    geometry={nodes.Smart_Cover_Fascia_inside_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[46.6, 0, 3.4]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[102, 0, 23.8]} rotation={[0, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_R1.geometry}
                    material={materials['physi alu bright']}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Fascia_inside_Corner_R2.geometry}
                    material={materials['physi alu bright']}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_R1.geometry}
                    material={materials.rubber}
                    position={[0, 0, -48.5]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Gasket_Fascia_inside_Corner_R2.geometry}
                    material={materials.rubber}
                    position={[48.5, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                  <mesh
                    geometry={nodes.Handrail_Endcap_Fascia_inside_Corner_R.geometry}
                    material={materials['physi alu bright']}
                    position={[23.91, 0, 0]}
                    rotation={[0, -1.57, 0]}
                  />
                </group>
                <group position={[53, -12.5, 23.8]} rotation={[-Math.PI / 2, 0, -Math.PI / 2]}>
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_inside_R1.geometry}
                    material={materials['Glass Frosted']}
                    position={[0.43, 0, 0]}
                  />
                  <mesh
                    geometry={nodes.Glass_Corner_Fascia_inside_R2.geometry}
                    material={materials['Glass Frosted']}
                    position={[-0.43, 0, 0]}
                  />
                </group>
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_R1.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -3.1, 10]}
                  rotation={[0, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Blind_Plug_Fascia_inside_R2.geometry}
                  material={materials['physi concrete']}
                  position={[5.18, -13.8, 20.75]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R1.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, 0, 4]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R2.geometry}
                  material={materials['physi alu bright']}
                  position={[1.5, -19.8, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Gasket_Fascia_inside_Corner_R1.geometry}
                  material={materials.rubber}
                  position={[1.5, 0, 4]}
                  rotation={[0, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Fascia_inside_Corner_R2_1.geometry}
                  material={materials.rubber}
                  position={[1.5, -19.8, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Smart_Endcap_Fascia_inside_Corner_R.geometry}
                  material={materials['physi alu bright']}
                  position={[5.9, -23.91, 23.8]}
                  rotation={[-Math.PI / 2, 0, Math.PI / 2]}
                />
                <mesh
                  geometry={nodes.Floor_Fascia_inside_R.geometry}
                  material={materials['physi concrete']}
                  position={[5.9, -10.3, 37.25]}
                  rotation={[Math.PI / 2, 0, -Math.PI / 2]}
                />
              </group>
            </group>
            {props.wall2 && wallrender(measureadjust, 2, 1)}
          </>
        )}

        {props.form == 'l' && topmount && (
          <group
            position={[0 - 0.1, 0, 0 + props.len2 / 200 + pointpointadjust]}
            visible={true}
            scale={[0.1 + 0.0005 - pointscaleadjust, 1, 1]}
            rotation-y={Math.PI / 2}
          >
            <Line
              points={[
                [0.3, -5, 0.241 + 0.45],
                [pointies2[pointies2.length - 1][1] + 5.1, -5, 0.241 + 0.45],
              ]}
            />
            <Line
              points={[
                [pointies2[pointies2.length - 1][1] + 5.1, -1.5, 0.241 + 0.45],
                [pointies2[pointies2.length - 1][1] + 5.1, -5.5, 0.241 + 0.45],
              ]}
              dashed={false}
            />
            <Line
              points={[[pointies2[0][1], -1.5, 0.241 + 0.45], [pointies2[0][1]], -5.5, 0.241 + 0.45]}
              dashed={false}
            />

            <Cone
              position={[
                pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83 - 0.3 + 5,
                -5,
                0.241 + 0.45,
              ]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
            <Cone
              position={[0.3 + 0.2, -5, 0.241 + 0.45]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
          </group>
        )}

        {props.form == 'l' && facial && (
          <group
            position={[0 - 0.1, 0, 0 + props.len2 / 200 + pointpointadjust]}
            visible={true}
            scale={[0.1 + 0.0005 - pointscaleadjust, 1, 1]}
            rotation-y={Math.PI / 2}
          >
            <Line
              points={[
                [0.3, -5, 0.241 - 0.45],
                [pointies2[pointies2.length - 1][1] - 5.1, -5, 0.241 - 0.45],
              ]}
            />
            <Line
              points={[
                [pointies2[pointies2.length - 1][1] - 5.1, -0.5, 0.241 - 0.45],
                [pointies2[pointies2.length - 1][1] - 5.1, -5.5, 0.241 - 0.45],
              ]}
              dashed={false}
            />
            <Line
              points={[[pointies2[0][1], -0.5, 0.241 - 0.45], [pointies2[0][1]], -5.5, 0.241 - 0.45]}
              dashed={false}
            />

            <Cone
              position={[
                pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83 - 0.3 - 5,
                -5,
                0.241 - 0.45,
              ]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
            <Cone
              position={[0.3 + 0.2 + 0.25, -5, 0.241 - 0.45]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
          </group>
        )}

        {props.form == 'u' && topmount && (
          <group
            position={[0 - 0.1, 0, 0 + props.len2 / 200 + pointpointadjust]}
            visible={true}
            scale={[0.1 + 0.0005 - pointscaleadjust, 1, 1]}
            rotation-y={Math.PI / 2}
          >
            <Line
              points={[
                [0.3 - 5.8, -5, 0.241 + 0.45],
                [pointies2[pointies2.length - 1][1] + 5.1, -5, 0.241 + 0.45],
              ]}
            />
            <Line
              points={[
                [pointies2[pointies2.length - 1][1] + 5.1, -1.5, 0.241 + 0.45],
                [pointies2[pointies2.length - 1][1] + 5.1, -5.5, 0.241 + 0.45],
              ]}
              dashed={false}
            />
            <Line
              points={[
                [pointies2[0][1] - 5.8, -1.5, 0.241 + 0.45],
                [pointies2[0][1] - 5.8, -5.5, 0.241 + 0.45],
              ]}
              dashed={false}
            />

            <Cone
              position={[
                pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83 - 0.3 + 5,
                -5,
                0.241 + 0.45,
              ]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
            <Cone
              position={[0.3 + 0.2 - 5.1, -5, 0.241 + 0.45]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
          </group>
        )}
        {props.form == 'u' && facial && (
          <group
            position={[0 - 0.1, 0, 0 + props.len2 / 200 + pointpointadjust]}
            visible={true}
            scale={[0.1 + 0.0005 - pointscaleadjust, 1, 1]}
            rotation-y={Math.PI / 2}
          >
            <Line
              points={[
                [0.3 + 3, -5, 0.241 - 0.45],
                [pointies2[pointies2.length - 1][1] - 5.1, -5, 0.241 - 0.45],
              ]}
            />
            <Line
              points={[
                [pointies2[pointies2.length - 1][1] - 5.1, -0.5, 0.241 - 0.45],
                [pointies2[pointies2.length - 1][1] - 5.1, -5.5, 0.241 - 0.45],
              ]}
              dashed={false}
            />
            <Line
              points={[[pointies2[0][1] + 3.3, -0.5, 0.241 - 0.45], [pointies2[0][1] + 3.3], -5.5, 0.241 - 0.45]}
              dashed={false}
            />

            <Cone
              position={[
                pointies2[pointies2.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83 - 0.3 - 5,
                -5,
                0.241 - 0.45,
              ]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
            <Cone
              position={[0.3 + 0.2 + 0.25 + 3.4, -5, 0.241 - 0.45]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
          </group>
        )}

        {props.montageart == 'top' && (
          <Text
            color={'black'}
            position={[
              -(pointies[0][1] + pointies[pointies.length - 1][1] / 20),
              -6 - textup,
              -pointies2[pointies2.length - 1][1] / 20,
            ]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            A :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len1 + ' mm' : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
          </Text>
        )}
        {props.montageart != 'top' && (
          <Text
            color={'black'}
            position={[
              -(pointies[0][1] + pointies[pointies.length - 1][1] / 20),
              -6 - textup,
              -pointies2[pointies2.length - 1][1] / 20,
            ]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            A :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len1 + ' mm' : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
          </Text>
        )}

        {topmount && (
          <Text
            color={'black'}
            position={[-pointies[pointies.length - 1][1] / 10, 5, -props.len2 / 200 - 5.85]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            {para.count != ('en-us' || 'es-us') ? props.hohe + ' mm' : muricaheight + ' "'}
          </Text>
        )}
        {facial && (
          <Text
            color={'black'}
            position={[-pointies[pointies.length - 1][1] / 10, 5.5, -props.len2 / 200 - 5.85]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            {para.count != ('en-us' || 'es-us') ? props.hohe + ' mm' : muricaheight + ' "'}
          </Text>
        )}

        {(props.form == 'l' || props.form == 'u') && props.montageart == 'top' && (
          <Text color={'black'} position={[0, -6 - textup, 0]} rotation-y={props.polarcoord} scale={textscale}>
            B :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len2 + ' mm' : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
          </Text>
        )}
        {(props.form == 'l' || props.form == 'u') && props.montageart != 'top' && (
          <Text color={'black'} position={[0, -6 - textup, 0]} rotation-y={props.polarcoord} scale={textscale}>
            B :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len2 + ' mm' : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
          </Text>
        )}
        {props.form == 'u' && props.montageart == 'top' && (
          <Text
            color={'black'}
            position={[-(pointies3[0][1] + pointies3[pointies3.length - 1][1] / 20), -6 - textup, props.len2 / 200]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            C :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len3 + ' mm' : parseFloat(props.len3 / 25.4).toFixed(2) + ' "'}
          </Text>
        )}
        {props.form == 'u' && props.montageart != 'top' && (
          <Text
            color={'black'}
            position={[-(pointies3[0][1] + pointies3[pointies3.length - 1][1] / 20), -6 - textup, props.len2 / 200]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            C :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len3 + ' mm' : parseFloat(props.len3 / 25.4).toFixed(2) + ' "'}
          </Text>
        )}

        {props.form == 'i' && facial && (
          <group position={[0, 0, 0 - props.len2 / 200]} visible={true} scale={[0.1, 1, 1]} rotation-y={Math.PI}>
            <Line
              points={[
                [0.3, -5, 0.241],
                [pointies[pointies.length - 1][1], -5, 0.241],
              ]}
            />
            <Line
              points={[
                [pointies[pointies.length - 1][1], -0.5, 0.241],
                [pointies[pointies.length - 1][1]],
                -5.5,
                0.241,
              ]}
              dashed={false}
            />
            <Line points={[[pointies[0][1], -0.5, 0.241], [pointies[0][1]], -5.5, 0.241]} dashed={false} />

            <Cone
              position={[pointies[pointies.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83, -5, 0.241]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
            <Cone
              position={[0.3 + 0.2 + 0.8, -5, 0.241]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
          </group>
        )}

        {props.form == 'i' && topmount && (
          <group position={[0, 0, 0 - props.len2 / 200]} visible={true} scale={[0.1, 1, 1]} rotation-y={Math.PI}>
            <Line
              points={[
                [0.3, -5, 0.241],
                [pointies[pointies.length - 1][1], -5, 0.241],
              ]}
            />
            <Line
              points={[
                [pointies[pointies.length - 1][1], -1.5, 0.241],
                [pointies[pointies.length - 1][1]],
                -5.5,
                0.241,
              ]}
              dashed={false}
            />
            <Line points={[[pointies[0][1], -1.5, 0.241], [pointies[0][1]], -5.5, 0.241]} dashed={false} />

            <Cone
              position={[pointies[pointies.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83, -5, 0.241]}
              scale={[0.1, 0.4, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
            <Cone
              position={[0.3 + 0.2, -5, 0.241]}
              scale={[0.1, 0.4, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
          </group>
        )}

        {(props.form == 'l' || props.form == 'u') && topmount && (
          <group
            position={[0 + 0.05, 0, 0 - props.len2 / 200]}
            visible={true}
            scale={[0.1 + 0.0005, 1, 1]}
            rotation-y={Math.PI}
          >
            <Line
              points={[
                [0.3 - 5.1, -5, 0.241 + 0.45],
                [pointies[pointies.length - 1][1], -5, 0.241 + 0.45],
              ]}
            />
            <Line
              points={[
                [pointies[pointies.length - 1][1], -1.5, 0 + 0.45 + 0.241],
                [pointies[pointies.length - 1][1]],
                -5.5,
                0 + 0.45 + 0.241,
              ]}
              dashed={false}
            />

            <Cone
              position={[pointies[pointies.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83, -5, 0.241 + 0.45]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
            <Cone
              position={[0.3 + 0.2 - 0.3 - 4.8, -5, 0.241 + 0.45]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
          </group>
        )}
        {(props.form == 'l' || props.form == 'u') && facial && (
          <group
            position={[0 + 0.05, 0, 0 - props.len2 / 200]}
            visible={true}
            scale={[0.1 + 0.0005, 1, 1]}
            rotation-y={Math.PI}
          >
            <Line
              points={[
                [0.3 + 3.3, -5, 0.241 - pickyadjust],
                [pointies[pointies.length - 1][1], -5, 0.241 - pickyadjust],
              ]}
            />
            <Line
              points={[
                [pointies[pointies.length - 1][1], -0.5, 0 - pickyadjust + 0.241],
                [pointies[pointies.length - 1][1]],
                -5.5,
                0 - pickyadjust + 0.241,
              ]}
              dashed={false}
            />

            <Cone
              position={[pointies[pointies.length - 1][1] + measureadjust + 0.3 - 0.2 - 0.83, -5, 0.241 - pickyadjust]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={-Math.PI / 2}
            />
            <Cone
              position={[0.3 + 0.2 - 0.3 + 3.8, -5, 0.241 - pickyadjust]}
              scale={[0.1, 2, 0.1]}
              material-color={'black'}
              rotation-x={Math.PI / 2}
              rotation-z={Math.PI / 2}
            />
          </group>
        )}

        {props.form == 'u' && topmount && (
          <group
            position={[0 - 0.1, 0, 0 + props.len2 / 200]}
            visible={true}
            scale={[0.1, 1, 1]}
            rotation-y={Math.PI / 2}
          >
            <Line
              points={[
                [pointies2[0][1] - 1.3 - 4.5, -5, 0.241 + 0.45],
                [pointies2[0][1] - 1.3 - 4.5, -5, -(pointies3[pointies3.length - 1][1] / 10)],
              ]}
            />

            <Line
              points={[
                [pointies2[0][1] - 1.3 - 4.5, -1.5, -(pointies3[pointies3.length - 1][1] / 10)],
                [pointies2[0][1] - 1.3 - 4.5],
                -5.5,
                -(pointies3[pointies3.length - 1][1] / 10),
              ]}
              dashed={false}
            />

            <Cone
              position={[pointies2[0][1] - 1.3 - 4.5, -5, -(pointies3[pointies3.length - 1][1] / 10) + 0.1]}
              scale={[0.1, 0.2, 1]}
              material-color={'black'}
              rotation-z={-Math.PI / 2}
              rotation-y={Math.PI / 2}
            />
            <Cone
              position={[pointies2[0][1] - 5.8, -5, 0.241 + 0.45 - 0.1]}
              scale={[0.1, 0.2, 1]}
              material-color={'black'}
              rotation-z={-Math.PI / 2}
              rotation-y={-Math.PI / 2}
            />
          </group>
        )}

        {props.form == 'u' && facial && (
          <group
            position={[0 - 0.1, 0, 0 + props.len2 / 200]}
            visible={true}
            scale={[0.1, 1, 1]}
            rotation-y={Math.PI / 2}
          >
            <Line
              points={[
                [pointies2[0][1] + 3.2, -5, 0.241 - 0.45],
                [pointies2[0][1] + 3.2, -5, -(pointies3[pointies3.length - 1][1] / 10)],
              ]}
            />

            <Line
              points={[
                [pointies2[0][1] + 3.2, -0.5, -(pointies3[pointies3.length - 1][1] / 10)],
                [pointies2[0][1] + 3.2],
                -5.5,
                -(pointies3[pointies3.length - 1][1] / 10),
              ]}
              dashed={false}
            />

            <Cone
              position={[pointies2[0][1] + 3.2, -5, -(pointies3[pointies3.length - 1][1] / 10) + 0.1]}
              scale={[0.1, 0.2, 1]}
              material-color={'black'}
              rotation-z={-Math.PI / 2}
              rotation-y={Math.PI / 2}
            />
            <Cone
              position={[pointies2[0][1] + 3.2, -5, 0.241 - 0.45 - 0.1]}
              scale={[0.1, 0.2, 1]}
              material-color={'black'}
              rotation-z={-Math.PI / 2}
              rotation-y={-Math.PI / 2}
            />
          </group>
        )}

        {topmount && (
          <group position={[0, 0, 0 - props.len2 / 200]} visible={true} scale={[0.1, 1, 1]} rotation-y={Math.PI}>
            <Line
              points={[
                [pointies[pointies.length - 1][1], 0, 0.241 + 3.5],
                [pointies[pointies.length - 1][1], 10.345 + heightmeasureadjust + heightmove / 10, 0.241 + 3.5],
              ]}
            />
            <Line
              points={[[pointies[pointies.length - 1][1], 0, 0.241], [pointies[pointies.length - 1][1]], 0, 0.241 + 4]}
              dashed={false}
            />

            <Line
              points={[
                [pointies[pointies.length - 1][1], 10.345 + heightmeasureadjust + heightmove / 10, 0.241],
                [pointies[pointies.length - 1][1]],
                10.345 + heightmeasureadjust + heightmove / 10,
                0.241 + 4,
              ]}
              dashed={false}
            />
            <Cone
              position={[
                pointies[pointies.length - 1][1],
                10.345 + heightmeasureadjust - 0.2 + heightmove / 10,
                0.241 + 3.5,
              ]}
              scale={[1, 0.4, 0.1]}
              material-color={'black'}
              rotation-y={-Math.PI}
            />
            <Cone
              position={[pointies[pointies.length - 1][1], 0.2, 0.241 + 3.5]}
              scale={[1, 0.4, 0.1]}
              material-color={'black'}
              rotation-x={-Math.PI}
            />
          </group>
        )}
        {facial && (
          <group position={[0, 0, 0 - props.len2 / 200]} visible={true} scale={[0.1, 1, 1]} rotation-y={Math.PI}>
            <Line
              points={[
                [pointies[pointies.length - 1][1], 0 + 1.19, 0.241 + 3.5],
                [pointies[pointies.length - 1][1], 10.345 + heightmeasureadjust + heightmove / 10, 0.241 + 3.5],
              ]}
            />
            <Line
              points={[
                [pointies[pointies.length - 1][1], 0 + 1.19, 0.241],
                [pointies[pointies.length - 1][1]],
                0 + 1.19,
                0.241 + 4,
              ]}
              dashed={false}
            />

            <Line
              points={[
                [pointies[pointies.length - 1][1], 10.345 + heightmeasureadjust + heightmove / 10, 0.241],
                [pointies[pointies.length - 1][1]],
                10.345 + heightmeasureadjust + heightmove / 10,
                0.241 + 4,
              ]}
              dashed={false}
            />
            <Cone
              position={[
                pointies[pointies.length - 1][1],
                10.345 + heightmeasureadjust - 0.2 + heightmove / 10,
                0.241 + 3.5,
              ]}
              scale={[1, 0.4, 0.1]}
              material-color={'black'}
              rotation-y={-Math.PI}
            />
            <Cone
              position={[pointies[pointies.length - 1][1], 0.2 + 1.19, 0.241 + 3.5]}
              scale={[1, 0.4, 0.1]}
              material-color={'black'}
              rotation-x={-Math.PI}
            />
          </group>
        )}
      </group>
    </>
  );
}

export default Glassmodel;
